import { IdPersistence } from "../constants/IdPersistence";
var UtilServerPersistence = /** @class */ (function () {
    function UtilServerPersistence() {
        var _this = this;
        this.IdServerPersistenceNumberValue = [
            IdPersistence.CoopPreviousLevel,
            IdPersistence.CoopPreviousRanking,
            IdPersistence.PlayerLeaguePreviousRanking,
        ];
        this.convertServerPersistenceValue = function (id, value) {
            if (_this.IdServerPersistenceNumberValue.indexOf(id) >= 0) {
                return parseInt(value, 10);
            }
            return value;
        };
    }
    return UtilServerPersistence;
}());
export var utilServerPersistence = new UtilServerPersistence();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilServerPersistence.ts
// module id = 890
// module chunks = 3